import './styles.scss';
import { FC } from 'react';
import { ModalDeleteTicketInterface } from './indexModel';
import { Modal } from 'react-bootstrap';
import Loading from '../../../../../components/loading2';
import { IconX } from '@tabler/icons-react';

const ModalDeleteTicket: FC<ModalDeleteTicketInterface> = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={() => props.hide(false)}
      aria-labelledby=""
      size="sm"
      centered={true}
      dialogClassName="modal-delete-ticket-component"
    >
      <Modal.Header>
        <Modal.Title>
          {props.t('title')}
        </Modal.Title>
        <div className="modal-delete-ticket-header-actions">
          <IconX onClick={() => props.hide(false)} />
        </div>
      </Modal.Header>
      <Modal.Body>
        { (!props.data || props.loadingDelete) && <Loading blur={true}/>}
        { props.data &&
          <span className="modal-delete-ticket-message">
            {props.t('message_1')} <span>#{props.data.ticketReferenceId}</span>. {props.t('message_2')}
          </span>
        }
      </Modal.Body>
      <Modal.Footer>
        <button className='modal-delete-ticket-btn-cancel' onClick={() => props.hide(false)}>{props.t('btn_cancel')}</button>
        <button className='modal-delete-ticket-btn-save' disabled={props.loadingDelete} onClick={() => props.handleSubmit()}>{props.t('btn_delete')}</button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDeleteTicket;
